/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Layout from "../../components/Layout";
import { Artwork } from "../../client";
import { Link } from "react-router-dom";
import MediaImage, {
  MediaImageFit,
  SizesEnum,
} from "../../components/MediaImage";
import { useArtworkList } from "../../client";
import { orderBy } from "lodash";
import { styled } from "../../stitches.config";

const StyledMediaImage = styled(MediaImage, {
  height: "100%",
  width: "100%",
});

const Title = styled("h3", {
  backgroundColor: "rgba(0,0,0,0.7)",
  position: "absolute",
  bottom: "0px",
  left: 0,
  right: 0,
  padding: "10px",
  fontSize: "18px",
  color: "$primary",
  margin: 0,
});

const ThumbnailContainer = styled(Link, {
  position: "relative",
  width: "100%",
  height: "150px",
  marginBottom: "5px",
  display: "block",
  "@media (min-width: 600px)": {
    height: "300px",
  },
});

const ArtworkGroupContainer = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  "@media (min-width: 600px)": {
    display: "grid",
    gridGap: "20px",
    gridTemplateColumns: "49% 49%",
  },
  "@media (min-width: 900px)": {
    gridTemplateColumns: "32% 32% 32%",
  },
});

export const Thumbnail = ({ artwork }: { artwork: Artwork }) => {
  return (
    <ThumbnailContainer to={`/${artwork.id}`}>
      <StyledMediaImage
        artwork={artwork}
        fit={MediaImageFit.COVER}
        size={SizesEnum.Medium}
        width={500}
        height={500}
        jpgQuality={50}
      />
      <Title>{artwork.title}</Title>
    </ThumbnailContainer>
  );
};

export const ArtworkGroup = ({ data }: { data: Artwork[] }) => {
  return (
    <div>
      <ArtworkGroupContainer>
        {orderBy(data, ["year"], ["desc"]).map((artwork) => (
          <Thumbnail key={artwork.id} artwork={artwork} />
        ))}
      </ArtworkGroupContainer>
    </div>
  );
};

export const Home = () => {
  const [artworks] = useArtworkList();

  console.log("artworks", artworks);

  return (
    <Layout>
      <ArtworkGroup data={artworks} />
    </Layout>
  );
};

export default Home;
